import React from 'react';
import { Images, renderClientName, renderStaffName } from 'utils';

export const MultiStaffBox = ({ list, removeSingle, removeAll, type }) => {
    return (
        <div>
            {!!list?.length && (
                <div className="selected-filter-box">
                    <div className="flex-end">
                        <button className="remove-all-btn" onClick={removeAll}>
                            <img
                                style={{
                                    filter: 'brightness(0) saturate(100%) invert(29%) sepia(8%) saturate(1592%) hue-rotate(176deg) brightness(101%) contrast(85%)',
                                }}
                                src={Images.closeGray}
                                alt="close"
                            />
                        </button>
                    </div>
                    {list?.map((i, j) => (
                        <div className="flex-align-center" style={{ gap: 8 }} key={j}>
                            <img src={Images.personIcon} alt="user" />
                            <p>{type === 'client' ? renderClientName(i) : renderStaffName(i)}</p>
                            <button className="reset-btn-by-default" onClick={() => removeSingle(i)}>
                                <img
                                    style={{
                                        filter: 'brightness(0) saturate(100%) invert(29%) sepia(8%) saturate(1592%) hue-rotate(176deg) brightness(101%) contrast(85%)',
                                    }}
                                    src={Images.closeGray}
                                    alt="close"
                                />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
